import { render } from "./add_user.vue?vue&type=template&id=3329ffd9&scoped=true"
import script from "./add_user.vue?vue&type=script&lang=js"
export * from "./add_user.vue?vue&type=script&lang=js"

import "./add_user.vue?vue&type=style&index=0&id=3329ffd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3329ffd9"]])

export default __exports__